import moment from 'moment'
import React, { useState } from 'react'
import { DatePicker, Dropdown, Menu } from 'antd'
import { Route, Switch, useHistory, Link } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, useListData } from '../../modules'

import Receive from '../../components/reusable/receive'

import Invoice from '../../components/drawers/invoice'
import NewInvoice from '../../components/drawers/newInvoice'

const { RangePicker } = DatePicker

const Invoices = () => {
    const [ranges, setRanges] = useState()
    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [token, setToken] = useState()

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [committed, toggleCommitted] = useToggle()

    const [
        { loading: invLoading, error: invError, fetch },
        { list: invoices },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('invoices', ranges ?
        { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null, committed }
        : { string, committed }
        , { notify: true, manual: false })

    const refetch = () => {
        fetch()
        navigate(1)
    }

    const selectRange = range => {
        setRanges(range)
        refetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="flex justify-between items-center mt-1 mb-5">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Invoice Using Code" />
                <span className="flex items-center">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                    <Link to="/app/accounts/purchases/invoices/new">
                        <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">New Invoice</button>
                    </Link>
                </span>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Invoices</h2>
                </header>
                <Receive
                    error={invError}
                    loading={invLoading}
                    progress>
                    {
                        invoices.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Code</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Supplier</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Status</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        invoices.map((invoice, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{invoice?.code}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{invoice?.supplier?.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{invoice?.committed ? 'Committed' : 'Commit Pending'}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{stringifyDate(invoice.date)}</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Link to={`/app/accounts/purchases/invoices/${invoice._id}`}>
                                                                    <Menu.Item>View</Menu.Item>
                                                                </Link>
                                                                {
                                                                    !invoice?.committed &&
                                                                    <>
                                                                        <Menu.Item>Commit Invoice</Menu.Item>
                                                                        <Menu.Item>Delete Invoice</Menu.Item>
                                                                    </>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please click above to add a new invoice</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
            <Switch>
                <Route path="/app/accounts/purchases/invoices/new">
                    <NewInvoice path="/app/accounts/purchases/invoices" onClose={refetch} />
                </Route>
                <Route path="/app/accounts/purchases/invoices/:id">
                    <Invoice path="/app/accounts/purchases" onClose={ refetch } />
                </Route>
            </Switch>
        </div>
    )
}

export default Invoices